const eventTarget = new EventTarget();

export const dispatchCompsChangeEvent = () => {
  eventTarget.dispatchEvent(new Event('compsChange'));
};

export const addCompsChangeListener = (callback: () => void) => {
  eventTarget.addEventListener('compsChange', callback);
};

export const removeCompsChangeListener = (callback: () => void) => {
  eventTarget.removeEventListener('compsChange', callback);
};
